import {Routes} from '@angular/router'
import {adminAuthGuard} from '@sparbanken-syd/sparbanken-syd-bankid'
import {
  BlancoDetailsComponent
} from './admin/blanco-details/blanco-details.component'
import {HomeComponent} from './admin/home/home.component'

export const routes: Routes = [
  {
    path: 'admin',
    component: HomeComponent
  },
  {
    path: 'admin/blanco/:id',
    component: BlancoDetailsComponent,
    canActivate: [adminAuthGuard]
  },
  {
    path: '**',
    redirectTo: 'admin',
    pathMatch: 'full'
  },
]